<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio-group
      v-model="model"
      :options="options"
      :aria-describedby="ariaDescribedby"
      button-variant="outline-primary"
      name="radio-btn-outline"
      buttons
    />
  </b-form-group>
  
</template>

<script>
import { BFormGroup, BFormRadioGroup } from "bootstrap-vue";
import AuthHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      branchedFilterOptions: [
       
        { text: "الكل", value: "all" },
        { text: "طلبات بحاجة تدقيق", value: "requests" },
        { text: "طلبات مرفوضة", value: "rejected" },
        { text: "طلبات مقبولة", value: "accepted" },
        { text: "طلبات مرفوضة من قبل الوزارة", value: "central_rejected" },
        { text: "طلبات مقبولة من قبل الوزارة", value: "central_accepted" },
      ],
      

      centralFilterOptions: [
        { text: "الكل", value: "all" },
        { text: "طلبات بحاجة تدقيق", value: "requests" },
        { text: "طلبات مرفوضة", value: "rejected" },
        { text: "طلبات مقبولة", value: "accepted" },
      ],
      model: "all",
    };
  },

  computed: {
    options() {
      return AuthHelpers.isUserCentral()
        ? this.centralFilterOptions
        : this.branchedFilterOptions;
    },
  },

  watch: {
    model(val) {
      this.$emit("filterChanged", val);
    },
  },
};
</script>
